import {createGlobalStyle} from 'styled-components';

import {getThemeColorVars} from './colors';
import gaps from './gaps';
import tints from './tints';

export default createGlobalStyle`
  :root {
    ${getThemeColorVars()}
    ${tints}
    ${gaps}
    
    --theme-placeholder-opacity: 0.5;

    --theme-tour-disabled-filter: opacity(25%);
    --theme-overline-opacity: 0.42;
    --theme-overline-filter: opacity(var(--theme-overline-opacity));
    --theme-disabled-filter: opacity(50%);
    --theme-deemphasize-opacity: 0.7;
    --theme-deemphasize-filter: opacity(var(--theme-deemphasize-opacity));

    --theme-font-family: 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    --theme-font-size-page-title: 1.125rem;
    --theme-font-size-title: 1rem;
    --theme-font-size-important: 1rem;
    --theme-font-size-paragraph: 0.875rem;
    --theme-font-size-badge: 0.875rem;
    --theme-font-size-secondary: 0.875rem;
    --theme-font-size-input: 0.875rem;
    --theme-font-size-control: 0.875rem;
    --theme-font-size-tiny: 0.75rem;

    --theme-font-weight: 400;
    --theme-font-weight-emphasize: 700;
    --theme-font-weight-black: 700;

    --theme-font-weight-title: var(--theme-font-weight-emphasize);
    --theme-font-weight-control: var(--theme-font-weight-emphasize);
    --theme-font-weight-badge: var(--theme-font-weight-emphasize);

    --theme-font-weight-stats: var(--theme-font-weight-black);
    --theme-font-weight-link: var(--theme-font-weight-emphasize);
    --theme-font-weight-info: var(--theme-font-weight);

    --theme-border-thickness: 0.0625rem;
    --theme-button-border-thickness: 0.09375rem;

    --theme-radius-sm: 0.5rem;
    --theme-radius: 0.75rem;
    --theme-modal-radius: 1.25rem;
    --theme-surface-radius: 0.75rem;
    --theme-circle-radius: 100em;
    --theme-tooltip-radius: 0.3125rem;

    --theme-shadow: 0px 1px 4px 0px rgb(0 0 0 / 0.06);
    --theme-big-shadow: 0px 3px 14px rgba(0 0 0 / 0.15);

    --theme-animation-movement-curve: cubic-bezier(0, 0, 0.25, 1);
  }

  body {
    font-family: var(--theme-font-family);
  }
`;
